import React from 'react'
import { Link } from 'react-router-dom'

import { certificacionesData } from '../data/data'

export default function Certificaciones() {
    return (
        <>
            <div className="row justify-content-center">
                {certificacionesData.map((item, index) => {
                    return (
                        <div className="col-lg-2 col-md-6 col-6 mt-4 pt-2" key={index}>
                            <div className="alianzas position-relative overflow-hidden rounded p-4 mx-auto">
                                <div className="position-relative">
                                    <div className="alianzas-image position-relative overflow-hidden text-center">
                                        <Link to='/certificaciones'>
                                            <img src={item.image} className="img-fluid" alt="" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
